import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "p-5" }
const _hoisted_2 = { class: "\n          d-flex\n          flex-wrap-reverse\n          align-items-end\n          justify-content-between\n          text-nowrap\n        " }
const _hoisted_3 = { class: "flex-column me-4" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { class: "mb-4 d-flex" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Slet rolle")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "row mt-5" }
const _hoisted_10 = { class: "col-md" }
const _hoisted_11 = { class: "col-md" }
const _hoisted_12 = { class: "mt-5 mb-4" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-labe",
  for: "adminCheck"
}, " Denne rolle aktiveres på vegne af ", -1)
const _hoisted_14 = { class: "mt-5 p-5 bg-info flex-grow-1" }
const _hoisted_15 = { class: "d-flex mb-3 align-items-center" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "flex-column me-4" }, [
  /*#__PURE__*/_createVNode("h2", null, "Organisationer med adgang"),
  /*#__PURE__*/_createVNode("small", null, "Nedenstående organisationer kan tildele deres brugere denne rolle")
], -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" + Tilføj organisation ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_pretty_bar = _resolveComponent("pretty-bar")!
  const _component_VDButton = _resolveComponent("VDButton")!
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_error = _resolveComponent("error")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_organizations_picker = _resolveComponent("organizations-picker")!
  const _component_sidebar = _resolveComponent("sidebar")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_sidebar, {
    isLoading: _ctx.loading,
    error: _ctx.error,
    class: "bg-white d-flex flex-column"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ConfirmPopup, {
        group: "sidebar",
        appendTo: "#sidebar"
      }),
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_pretty_bar),
            _createVNode("h2", null, _toDisplayString(_ctx.isNew ? "Opret rolle" : _ctx.role?.name), 1),
            _createVNode("h4", _hoisted_4, _toDisplayString(_ctx.role?.application?.name), 1)
          ]),
          _createVNode("div", _hoisted_5, [
            (!_ctx.isNew)
              ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_6, [
                  _createVNode(_component_VDButton, {
                    isDisabled: (_ctx.role?.assignees?.length ?? 0) > 0,
                    variant: "danger",
                    class: "me-2",
                    icon: "trash",
                    onClick: _ctx.deleteRole,
                    isLoading: _ctx.deleteMutation.loading.value
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["isDisabled", "onClick", "isLoading"])
                ], 512)), [
                  [_directive_tooltip, {
              value:
                'Ingen organisationer må have adgang til rollen før den kan slettes!',
              disabled: (_ctx.role?.assignees?.length ?? 0) < 1,
            }]
                ])
              : _createCommentVNode("", true),
            (_ctx.isNew || _ctx.hasChanges)
              ? (_openBlock(), _createBlock(_component_VDButton, {
                  key: 1,
                  icon: "check",
                  isDisabled: _ctx.v$.$error,
                  onClick: _ctx.onPrimaryButton,
                  isLoading: _ctx.primaryButtonLoading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.isNew ? "Opret" : "Gem ændringer"), 1)
                  ]),
                  _: 1
                }, 8, ["isDisabled", "onClick", "isLoading"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.role)
          ? (_openBlock(), _createBlock("form", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode(_component_o_field, {
                    variant: _ctx.v$.name.$error ? 'danger' : '',
                    label: "Navn *"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_o_input, {
                        ref: "nameInput",
                        modelValue: _ctx.role.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.role.name = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["variant"])
                ]),
                _createVNode("div", _hoisted_11, [
                  _createVNode(_component_o_field, {
                    variant: _ctx.v$.attribute.$error ? 'danger' : '',
                    label: "Attributværdi *"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_o_input, {
                        modelValue: _ctx.role.attribute,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.role.attribute = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["variant"])
                ]),
                _createVNode("div", _hoisted_12, [
                  _withDirectives(_createVNode("input", {
                    class: "form-check-input me-2",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.role.isOnBehalf = $event)),
                    id: "adminCheck"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.role.isOnBehalf]
                  ]),
                  _hoisted_13
                ])
              ]),
              _createVNode(_component_o_field, {
                class: "mt-3",
                label: "Beskrivelse"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_o_input, {
                    modelValue: _ctx.role.description,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.role.description = $event)),
                    type: "textarea",
                    rows: "2",
                    style: {"resize":"none"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_14, [
        _createVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(_component_Button, {
            disabled: _ctx.addRemoveLoading,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.organizationPicker?.toggle($event))),
            class: "ms-auto secondary text-nowrap"
          }, {
            default: _withCtx(() => [
              (_ctx.addRemoveLoading)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    class: "me-2",
                    spin: "",
                    icon: ['fas', 'spinner']
                  }))
                : _createCommentVNode("", true),
              _hoisted_17
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createVNode(_component_DataTable, {
          stripedRows: true,
          responsiveLayout: "scroll",
          value: _ctx.role?.assignees ?? [],
          selectionMode: "single"
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_error, { error: {
              title: 'Ingen organisationer',
              message:
                'Ingen organisationer har tilladelse til at tildele denne rolle til deres brugere.',
            } }, null, 8, ["error"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, { field: "name" }, {
              body: _withCtx(({ data }) => [
                _createVNode("span", null, _toDisplayString(data.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              style: {"width":"1px","white-space":"nowrap"},
              field: "menu"
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_Button, {
                  class: "danger inverted",
                  onClick: ($event: any) => (_ctx.onRemoveOrganization(data))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'minus'] })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_component_organizations_picker, {
          addedOrganizations: (_ctx.role.assignees ?? []).filter(Boolean) as _ctx.BasicOrganizationType[],
          disabled: _ctx.addRemoveLoading,
          onAddedOrganization: _ctx.onAddedOrganization,
          ref: "organizationPicker"
        }, null, 8, ["addedOrganizations", "disabled", "onAddedOrganization"])
      ])
    ]),
    _: 1
  }, 8, ["isLoading", "error"]))
}